import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
    WoSLAHistory
} from '../../work-order/work-order-models';

import { FPMessage, Severities, PageKey, RoleAccess } from '../../shared/shared.model';
import { WoService } from '../../work-order/work-order.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { PopupInit } from '../../shared/init-popup';
import { DatePipe } from '@angular/common';
import { Message, ConfirmationService } from 'primeng/primeng';

import { BaseComponent } from '../../shared/base.component';
import { CapitalizeFirstPipe } from '../../shared/pipes/custom-pipes.pipe';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
    // moduleId: module.id,
    selector: 'sla-details',
    templateUrl: 'sla-details.component.html'

})

export class SlaDetailsComponent extends BaseComponent implements OnInit {
    @Input() SLADetailsRights: RoleAccess = new RoleAccess;
    // woId: number;
    // customerId: number;

    // frmManageWo: FormGroup;
    // customertype: CustomerTypesEntity[];
    // timeZonelist: TimezoneEntity[];
    woSLAhistory: WoSLAHistory[];
    woslahistory: WoSLAHistory;
    // woStatus: WoStatusComp[];
    // isPMOrder: boolean = false;
    //  currentcustomer = new CustomerEntity;
    // HeaderName: string;
    // woJobId: number;
    // message: FPMessage;
    // currency: any;
    // private slaRights: RoleAccess = new RoleAccess;
    @Input() set WoId(value) {
        this._WoId.next(value);
    }
    get WoId() {
        return this._WoId.getValue();
    }

    @Input() jobId: number;
    @Input() jobNumber: number[];
    private _WoId = new BehaviorSubject<number>(null);

    WojobId: number;
    SLATypeId: number;
    Color: string;
    PriorityId: number;
    //@Input() JobStatusId:number;
    //  @Output()refreshSla=new EventEmitter();
    islookup: boolean = false;
    iseditlookup: boolean = false;

    frmSlaDetails: FormGroup;
    hoursStr: string;
    minStr: string;
    daysStr: string;
    SLAApplied: number;
    ischildWo: boolean = false;
    constructor(protected translateService: TranslateService, protected _woService: WoService,
        private formBuilder: FormBuilder, private route: ActivatedRoute,
        private datePipe: DatePipe, protected sharedService: SharedService) {
        super(sharedService, translateService)
        this.hoursStr = "hrs"; //this.translate.instant("HRS");
        this.minStr = "mins";//this.translate.instant("MINS");
        this.daysStr = "days";//this.translate.instant("DAYS");
    }
    ngOnInit() {
        this._WoId.subscribe(s => {
            this.frmSlaDetails = this.formBuilder.group({
                WorkOrderId: [this.WoId]
            });
            if (this.WoId) {
                this.frmSlaDetails.controls["WorkOrderId"].setValue(this.WoId);
                this.getSlaDetails(this.WoId);
            }
        });

        this._woService.linkedWo.subscribe(s => {
            this.ischildWo = s;          
         });
        // this.childPrivilagesRole();
    }
    openPopuplookup(value: WoSLAHistory) {

        this.WojobId = value.WoJobId;
        this.SLATypeId = value.SLATypeId;
        this.islookup = true;
    }
    openEditPopuplookup(value: WoSLAHistory) {
        
        this.WojobId = value.WoJobId;
        this.SLATypeId = value.SLATypeId;
        this.Color = value.Color;
        this.SLAApplied = value.SLAApplied;
        if (value.PriorityId) {
            this.PriorityId = value.PriorityId
        }
        else {
            this.PriorityId = 0;
        }
        this.iseditlookup = true;
    }
    closesearch() {

        this.islookup = false;
    }

    editclosesearch() {

        this.iseditlookup = false;
        if (this.frmSlaDetails.controls["WorkOrderId"].value) {

            this.getSlaDetails(this.frmSlaDetails.controls["WorkOrderId"].value);
        }
    }
    // childPrivilagesRole() {
    //     this.sharedService.getChildPrivileges(super.globalInfo().CompanyId, super.globalInfo().LoginId,
    //         PageKey.WO_MANAGE_WORK_ORDERS,
    //         PageKey.MANAGE_WO_PRICING).subscribe(s => s.map(m => this.pricingRights = m));

    // }

    getSlaDetails(WoId: number) {

        this._woService.getWoSLAHistory(this.globalInfo().CompanyId, WoId, this.jobId) //this.woId
            .subscribe(s => {

                this.woSLAhistory = s;
                this.woSLAhistory.map(x => {
                    x.CreatedDate = x.CreatedDate ? this.datePipe.transform(x.CreatedDate, 'short') : null;
                    x.ApptPrefDate = x.ApptPrefDate ? this.datePipe.transform(x.ApptPrefDate, 'short') : null;
                    x.SLAStartTime = x.SLAStartTime ? this.datePipe.transform(x.SLAStartTime, 'short') : null;
                    x.SLAEndTime = x.SLAEndTime ? this.datePipe.transform(x.SLAEndTime, 'short') : null;
                    x.ActualSLAEndTime = x.ActualSLAEndTime ? this.datePipe.transform(x.ActualSLAEndTime, 'short') : null;
                    // x.CreatedDate = this.datePipe.transform(x.CreatedDate, 'shortDate') +  + this.datePipe.transform(x.CreatedDate, 'shortTime'),
                    // x.ApptPrefDate = this.datePipe.transform(x.ApptPrefDate, 'shortDate') +  + this.datePipe.transform(x.ApptPrefDate, 'shortTime')

                    //x.Durationstr = this.durationCalc(x.Duration);
                    if (x.SLAType == 'Response' && x.RespSLADurationTypeId != 1 && x.RespSLADurationTypeId != 0) {
                        x.Durationstr = x.ResponseSLADurationType;
                    }
                    else if (x.SLAType == 'Resolution' && x.ReslSLADurationTypeId != 1 && x.ReslSLADurationTypeId != 0) {
                        x.Durationstr = x.ResolutionSLADurationType;
                    }
                    
                    x.isEdit = false;
                    if(this.jobNumber && this.jobNumber.length > 0){
                        x.isEdit = this.globalInfo().MaxRoleGroup == 2 ? false: (this.globalInfo().MaxRoleGroup == 3 || this.globalInfo().MaxRoleGroup == 5 || this.globalInfo().MaxRoleGroup == 6) ?  
                        this.jobNumber.indexOf(x.WoJobId) == -1 :  false;
                    }
                });
            });
    }

    durationCalc(val: number) {
        if (val <= 0) {
            return "";
        }
        var comStr = "";
        var hrs = 0;
        var days = 0;
        var i = 0, j = 0;
        if (val < 60) {
            comStr = 0 + " " + this.hoursStr + " " + val + " " + this.minStr;
            return comStr;
        }

        for (i = 60; i <= val;) {
            hrs = hrs + 1;
            i = i + 60;
        }
        i = i - 60;
        if (hrs >= 24) {
            for (j = 24; j <= hrs;) {
                days = days + 1;
                j = j + 24;
            }
            j = j - 24;
            comStr = days + " " + this.daysStr + " " + (hrs - j) + " " + this.hoursStr + " " + (val - i) + " " + this.minStr;
        }
        else
            comStr = hrs + " " + this.hoursStr + " " + (val - i) + " " + this.minStr;
        return comStr;
    }


}